import * as Utils from "../utils";

// The `date` param: a calendar date, or an instant, asked for with a picker.
//
// `format` is the standard JSON Schema keyword, and it is what
// @repoflow/form-schema's date widget reads to decide what the field STORES:
//
//   "date"       ->  "2026-03-14"                 a calendar date
//   "date-time"  ->  "2026-03-14T12:00:00.000Z"   an instant
//
// It is a real choice and not ceremony. A date of birth, a signature date and a
// reporting period are calendar dates: they have no time and no zone, and
// storing them as instants is the classic one-off — `toISOString()` renders the
// UTC day, so a date picked as local midnight comes back as the PREVIOUS day
// everywhere west of Greenwich, for the rest of that capture's life. When an
// incident time matters, "date-time" is the honest shape and the picker offers
// both halves.
export const schema = [
  {
    id: "/Types/Param/Type/Date",
    type: "object",
    properties: {
      ...Utils.properties,
      format: {
        label: "Stores",
        type: "string",
        enum: ["date", "date-time"],
        default: "date",
      },
      // Declared so that a date param's generated property carries a `default`
      // like every other type's, and NOT offered in the designer: the only
      // useful default for a capture field is "today", and a schema cannot say
      // that — `new Date()` in a schema document makes it differ between two
      // processes that loaded it a second apart, which is the mistake pagews'
      // date param records in its own file.
      default: {
        label: "Default value",
        type: "string",
        default: "",
      },
    },
    // Required, unlike `interval` on the time param next door, because the two
    // fallbacks differ in kind. An absent interval lands on the same 15 minutes
    // the widget itself defaults to, so nothing is lost. An absent format would
    // silently store instants in a field that was meant to hold calendar dates,
    // and nothing downstream could tell the difference — better a rejected
    // `table.update.invalid` than a column that quietly means something else.
    required: ["format"],
  },
];
